import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { dateTransformer } from '@/common/utils/dateTransformer'
import { formatCurrency, formatDate } from '@/common/utils/formatters'
import { paymentAdvanceStatus } from '@/features/paymentAdvances/constants/paymentAdvanceStatus.constant'
import { PaymentAdvanceData, PaymentAdvanceTableItem } from '@/features/paymentAdvances/types/paymentAdvance.type'
import { ArrowBigRightIcon, FuelIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class PaymentAdvancesTransformer {
  static tableTransformer() {
    return (paymentAdvances: PaymentAdvanceData[]): PaymentAdvanceTableItem[] => {
      return paymentAdvances.map((paymentAdvance) => ({
        id: paymentAdvance.id,
        establishment_company: (
          <ImageWithDisplayName
            placeholderIcon={FuelIcon}
            imageUrl={paymentAdvance.establishment_company?.general_information?.company_logo?.url}
            displayName={paymentAdvance.establishment_company?.general_information?.fantasy_name}
            imageClassName="size-6"
            iconClassName="size-4"
          />
        ),
        status: paymentAdvanceStatus[paymentAdvance.status] || '',
        bill_number: paymentAdvance.bill_number || '',
        discounted_from_bill: formatCurrency(Number(paymentAdvance.discounted_from_bill)),
        date_to_be_paid: dateTransformer(paymentAdvance.date_to_be_paid),
        created_at: formatDate(new Date(paymentAdvance.created_at)),
        actions: (
          <Link to={`/payment-advances/${paymentAdvance.id}`}>
            <ArrowBigRightIcon />
          </Link>
        ),
      }))
    }
  }
}
